/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          EM Service WebEntry API
Version:      1
Description:  Event Management Service WebEntry API provides all the Event and Data related calls for web entry.
Generated at: 05/12/2024 15:51 (GMT Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from '../Providers.Api/ApiError';
import { ODataSelect } from '../Providers.Api/ODataQuery';
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from '../Providers.Api/Models';
import { ApiHelper } from '../Providers.Api/ApiHelper';
import { IbssRequestConfig } from '../Providers.Api/ApiClient';

export interface IContext
{
    baseUrl: string;
}

export interface IEmServiceWebEntryApiClientV1
{
    api: IEmServiceWebEntryApiClientV1_Api;
    v1: IEmServiceWebEntryApiClientV1_V1;


}

export class EmServiceWebEntryApiClientV1 implements IEmServiceWebEntryApiClientV1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.api = new EmServiceWebEntryApiClientV1_Api(context);
        this.v1 = new EmServiceWebEntryApiClientV1_V1(context);
    }

    public api: EmServiceWebEntryApiClientV1_Api;
    public v1: EmServiceWebEntryApiClientV1_V1;


}

export interface IEmServiceWebEntryApiClientV1_Api
{
    v1: IEmServiceWebEntryApiClientV1_Api_V1;
    webentry: IEmServiceWebEntryApiClientV1_Api_Webentry;


}

export class EmServiceWebEntryApiClientV1_Api implements IEmServiceWebEntryApiClientV1_Api
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v1 = new EmServiceWebEntryApiClientV1_Api_V1(context);
        this.webentry = new EmServiceWebEntryApiClientV1_Api_Webentry(context);
    }

    public v1: EmServiceWebEntryApiClientV1_Api_V1;
    public webentry: EmServiceWebEntryApiClientV1_Api_Webentry;


}

export interface IEmServiceWebEntryApiClientV1_Api_V1
{
    byNodeid: IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid;


}

export class EmServiceWebEntryApiClientV1_Api_V1 implements IEmServiceWebEntryApiClientV1_Api_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNodeid = new EmServiceWebEntryApiClientV1_Api_V1_ByNodeid(context);
    }

    public byNodeid: EmServiceWebEntryApiClientV1_Api_V1_ByNodeid;


}

export interface IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid
{
    connectors: IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors;


}

export class EmServiceWebEntryApiClientV1_Api_V1_ByNodeid implements IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.connectors = new EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors(context);
    }

    public connectors: EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors;


}

export interface IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors
{
    byConnectorid: IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid;

    get<TResponse>(options: { nodeId: number, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IConnectorsVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors implements IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byConnectorid = new EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid(context);
    }

    public byConnectorid: EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid;


    public async get<TResponse>(options: { nodeId: number, filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/v1/${options.nodeId}/Connectors?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IConnectorsVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/v1/${options.nodeId}/Connectors?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid
{

    get<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, connectorid: number, body: IConnectorsUpdaTEVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid implements IEmServiceWebEntryApiClientV1_Api_V1_ByNodeid_Connectors_ByConnectorid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/v1/${options.nodeId}/Connectors/${options.connectorid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, connectorid: number, body: IConnectorsUpdaTEVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/v1/${options.nodeId}/Connectors/${options.connectorid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { nodeId: number, connectorid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/v1/${options.nodeId}/Connectors/${options.connectorid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry
{
    v1: IEmServiceWebEntryApiClientV1_Api_Webentry_V1;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry implements IEmServiceWebEntryApiClientV1_Api_Webentry
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v1 = new EmServiceWebEntryApiClientV1_Api_Webentry_V1(context);
    }

    public v1: EmServiceWebEntryApiClientV1_Api_Webentry_V1;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1
{
    eventListView: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView;
    eventTypePage: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage;
    file: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File;
    security: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security;
    landingTile: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile;
    notification: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification;
    spaces: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1 implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.eventListView = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView(context);
        this.eventTypePage = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage(context);
        this.file = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File(context);
        this.security = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security(context);
        this.landingTile = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile(context);
        this.notification = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification(context);
        this.spaces = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces(context);
    }

    public eventListView: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView;
    public eventTypePage: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage;
    public file: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File;
    public security: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security;
    public landingTile: EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile;
    public notification: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification;
    public spaces: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView
{
    byId: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById;

    post<TResponse>(options: { body: IEventListViewSettingsEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { name?: string, eventType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById(context);
    }

    public byId: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById;


    public async post<TResponse>(options: { body: IEventListViewSettingsEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/EventListView?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { name?: string, eventType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}
            if (options.eventType) { queryParts.push(`eventType=${encodeURIComponent(options.eventType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventListView?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById
{

    put<TResponse>(options: { id: number, body: IEventListViewSettingsEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventListView_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { id: number, body: IEventListViewSettingsEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/EventListView/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/EventListView/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventListView/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage
{
    byId: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById;
    getForEventType: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType;

    post<TResponse>(options: { body: IEventTypePageEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { name?: string, loadDisabled?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById(context);
        this.getForEventType = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType(context);
    }

    public byId: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById;
    public getForEventType: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType;


    public async post<TResponse>(options: { body: IEventTypePageEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/EventTypePage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { name?: string, loadDisabled?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}
            if (options.loadDisabled) { queryParts.push(`loadDisabled=${encodeURIComponent(options.loadDisabled)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventTypePage?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById
{
    toggle: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle;

    put<TResponse>(options: { id: number, body: IEventTypePageEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.toggle = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle(context);
    }

    public toggle: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle;


    public async put<TResponse>(options: { id: number, body: IEventTypePageEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/EventTypePage/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/EventTypePage/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventTypePage/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle
{

    get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_ById_Toggle
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventTypePage/${options.id}/toggle?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType
{
    byEventtypeid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEventtypeid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid(context);
    }

    public byEventtypeid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid
{

    get<TResponse>(options: { eventtypeid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_EventTypePage_GetForEventType_ByEventtypeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { eventtypeid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/EventTypePage/GetForEventType/${options.eventtypeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File
{
    byPath: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath;
    folder: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder;
    download: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byPath = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath(context);
        this.folder = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder(context);
        this.download = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download(context);
    }

    public byPath: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath;
    public folder: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder;
    public download: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath
{

    post<TResponse>(options: { path: string, processAsMapFile?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_ByPath
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { path: string, processAsMapFile?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.processAsMapFile) { queryParts.push(`ProcessAsMapFile=${encodeURIComponent(options.processAsMapFile)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/File/${options.path}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/File/${options.path}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/File/${options.path}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder
{
    byPath: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byPath = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath(context);
    }

    public byPath: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath
{

    delete<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Folder_ByPath
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/File/Folder/${options.path}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download
{
    byPath: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byPath = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath(context);
    }

    public byPath: EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath
{

    get<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_File_Download_ByPath
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { path: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/File/Download/${options.path}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security
{
    identityProviders: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders;
    roleDataSecurity: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity;
    roles: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles;
    userRoles: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles;
    users: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.identityProviders = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders(context);
        this.roleDataSecurity = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity(context);
        this.roles = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles(context);
        this.userRoles = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles(context);
        this.users = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users(context);
    }

    public identityProviders: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders;
    public roleDataSecurity: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity;
    public roles: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles;
    public userRoles: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles;
    public users: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders
{
    byIdentityproviderid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IIdentityProvidePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byIdentityproviderid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid(context);
    }

    public byIdentityproviderid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IIdentityProvidePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid
{
    users: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users;
    roles: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles;

    get<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { identityproviderid: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { identityproviderid: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.users = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users(context);
        this.roles = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles(context);
    }

    public users: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users;
    public roles: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles;


    public async get<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { identityproviderid: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { identityproviderid: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users
{

    get<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { identityproviderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}/users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles
{

    get<TResponse>(options: { identityproviderid: number, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_IdentityProviders_ByIdentityproviderid_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { identityproviderid: number, debug?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.debug) { queryParts.push(`debug=${encodeURIComponent(options.debug)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/IdentityProviders/${options.identityproviderid}/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile
{
    byId: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById;

    post<TResponse>(options: { body: ILandingTileEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById(context);
    }

    public byId: EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById;


    public async post<TResponse>(options: { body: ILandingTileEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/LandingTile?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { name?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.name) { queryParts.push(`name=${encodeURIComponent(options.name)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/LandingTile?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById
{

    put<TResponse>(options: { id: number, body: ILandingTileEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_LandingTile_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { id: number, body: ILandingTileEntity, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/LandingTile/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/LandingTile/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/LandingTile/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification
{
    byId: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById;
    refresh: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: INotificationPostVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById(context);
        this.refresh = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh(context);
    }

    public byId: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById;
    public refresh: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Notification?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: INotificationPostVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Notification?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById
{

    get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { id: number, body: INotificationUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Notification/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: number, body: INotificationUpdateVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Notification/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Notification/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh
{

    put<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Notification_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Notification/refresh?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity
{
    byRoleid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRoleid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid(context);
    }

    public byRoleid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid
{

    get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { roleid: string, body: ISecurityModelUpdateModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_RoleDataSecurity_ByRoleid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/RoleDataSecurity/${options.roleid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { roleid: string, body: ISecurityModelUpdateModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Security/RoleDataSecurity/${options.roleid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles
{
    byRoleid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid;
    availableRights: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights;

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IRolesPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRoleid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid(context);
        this.availableRights = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights(context);
    }

    public byRoleid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid;
    public availableRights: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights;


    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IRolesPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Security/Roles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid
{
    users: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users;

    get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { roleid: string, body: IRolesPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.users = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users(context);
    }

    public users: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users;


    public async get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Roles/${options.roleid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { roleid: string, body: IRolesPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Security/Roles/${options.roleid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Security/Roles/${options.roleid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users
{

    get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_ByRoleid_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Roles/${options.roleid}/users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Roles_AvailableRights
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Roles/AvailableRights?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_V1
{
    service: IEmServiceWebEntryApiClientV1_V1_Service;


}

export class EmServiceWebEntryApiClientV1_V1 implements IEmServiceWebEntryApiClientV1_V1
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.service = new EmServiceWebEntryApiClientV1_V1_Service(context);
    }

    public service: EmServiceWebEntryApiClientV1_V1_Service;


}

export interface IEmServiceWebEntryApiClientV1_V1_Service
{
    heartbeat: IEmServiceWebEntryApiClientV1_V1_Service_Heartbeat;
    version: IEmServiceWebEntryApiClientV1_V1_Service_Version;


}

export class EmServiceWebEntryApiClientV1_V1_Service implements IEmServiceWebEntryApiClientV1_V1_Service
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.heartbeat = new EmServiceWebEntryApiClientV1_V1_Service_Heartbeat(context);
        this.version = new EmServiceWebEntryApiClientV1_V1_Service_Version(context);
    }

    public heartbeat: EmServiceWebEntryApiClientV1_V1_Service_Heartbeat;
    public version: EmServiceWebEntryApiClientV1_V1_Service_Version;


}

export interface IEmServiceWebEntryApiClientV1_V1_Service_Heartbeat
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_V1_Service_Heartbeat implements IEmServiceWebEntryApiClientV1_V1_Service_Heartbeat
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/heartbeat?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_V1_Service_Version
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_V1_Service_Version implements IEmServiceWebEntryApiClientV1_V1_Service_Version
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v1/Service/version?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces
{
    bySpaceId: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId;
    bySpaceid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid;
    ibssspacetypes: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes;
    ibssspaceworktypes: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes;
    ibssspaceclasses: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses;

    get<TResponse>(options: { nodeId?: number, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IPostSpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceId = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId(context);
        this.bySpaceid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid(context);
        this.ibssspacetypes = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes(context);
        this.ibssspaceworktypes = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes(context);
        this.ibssspaceclasses = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses(context);
    }

    public bySpaceId: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId;
    public bySpaceid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid;
    public ibssspacetypes: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes;
    public ibssspaceworktypes: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes;
    public ibssspaceclasses: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses;


    public async get<TResponse>(options: { nodeId?: number, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.nodeId) { queryParts.push(`nodeId=${encodeURIComponent(options.nodeId)}`);}
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IPostSpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Spaces?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId
{
    hasPart: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart;
    isPartOf: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf;
    agents: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents;
    parameters: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters;
    devices: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices;
    spacestates: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates;
    taskcategories: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories;
    taskstates: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates;
    tasktypes: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes;

    get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.hasPart = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart(context);
        this.isPartOf = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf(context);
        this.agents = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents(context);
        this.parameters = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters(context);
        this.devices = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices(context);
        this.spacestates = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates(context);
        this.taskcategories = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories(context);
        this.taskstates = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates(context);
        this.tasktypes = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes(context);
    }

    public hasPart: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart;
    public isPartOf: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf;
    public agents: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents;
    public parameters: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters;
    public devices: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices;
    public spacestates: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates;
    public taskcategories: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories;
    public taskstates: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates;
    public tasktypes: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes;


    public async get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart
{

    get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_HasPart
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/hasPart?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf
{

    get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_IsPartOf
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { filter?: string, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/isPartOf?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents
{

    get<TResponse>(options: { spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Agents
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/agents?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters
{

    get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Parameters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/parameters?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid
{

    put<TResponse>(options: { spaceid: string, body: IUpdateSpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { spaceid: string, body: IUpdateSpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices
{

    get<TResponse>(options: { spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Devices
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/devices?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates
{

    get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Spacestates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/spacestates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories
{

    get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskcategories
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/taskcategories?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates
{

    get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Taskstates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/taskstates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes
{

    get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_BySpaceId_Tasktypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { recursive?: boolean, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/${options.spaceId}/tasktypes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspacetypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/ibssspacetypes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceworktypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/ibssspaceworktypes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Spaces_Ibssspaceclasses
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Spaces/ibssspaceclasses?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles
{
    byUserid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid;

    post<TResponse>(options: { body: IPostUserAddRoleModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byUserid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid(context);
    }

    public byUserid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid;


    public async post<TResponse>(options: { body: IPostUserAddRoleModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Security/UserRoles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid
{
    byRoleid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid;


}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRoleid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid(context);
    }

    public byRoleid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid;


}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid
{

    delete<TResponse>(options: { userid: string, roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_UserRoles_ByUserid_ByRoleid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { userid: string, roleid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Security/UserRoles/${options.userid}/${options.roleid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users
{
    byUserid: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid;

    get<TResponse>(options: { filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IUserPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byUserid = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid(context);
    }

    public byUserid: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid;


    public async get<TResponse>(options: { filter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IUserPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/api/webentry/v1/Security/Users?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid
{
    roles: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles;
    availableRoles: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles;
    resetpassword: IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword;

    get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { userid: string, body: IUpdateUserModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    delete<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.roles = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles(context);
        this.availableRoles = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles(context);
        this.resetpassword = new EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword(context);
    }

    public roles: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles;
    public availableRoles: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles;
    public resetpassword: EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword;


    public async get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { userid: string, body: IUpdateUserModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async delete<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles
{

    get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles
{

    get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_AvailableRoles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}/available-roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword
{

    put<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class EmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword implements IEmServiceWebEntryApiClientV1_Api_Webentry_V1_Security_Users_ByUserid_Resetpassword
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/api/webentry/v1/Security/Users/${options.userid}/resetpassword?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IConnectorsVM
{
    connectorName?: string | null;
    connectorType?: number;
    connectorSystem?: string | null;
    connectorApiVersion?: number;
    connectorUrl?: string | null;
    connectorAuthentication?: number;
    connectorCredentials?: string | null;
    connectorConfiguration?: string | null;

}

export interface IConnectorsUpdaTEVM
{
    connectorName?: string | null;
    connectorType?: number | null;
    connectorSystem?: string | null;
    connectorApiVersion?: number | null;
    connectorUrl?: string | null;
    connectorAuthentication?: number | null;
    connectorCredentials?: string | null;
    connectorConfiguration?: string | null;

}

export interface IEventListViewSettingsEntity
{
    id?: number;
    name?: string | null;
    url?: string | null;
    newEventTypePage?: IEventTypePageEntity;
    columns?: IEventListViewColumnEntity[] | null;
    webEntries?: IEventListViewSettingsEntityEventTypePageEntity[] | null;
    roles?: IEventListViewSettingsEntityEMServiceRoleIdentity[] | null;
    visibleInMenu?: boolean;

}

export interface IEventTypePageEntity
{
    id?: number;
    name?: string | null;
    disabled?: boolean;
    allowAssociatedEvents?: boolean;
    disableAttachments?: boolean;
    eventType?: IEventTypeEntity;
    eventType_ID?: number | null;
    isDefaultForm?: boolean;
    pageType?: EventTypePageType;
    roles?: IEventTypePageEntityEMServiceRoleIdentity[] | null;
    groups?: IEventFieldGroupEntity[] | null;
    associatedEventDataViews?: IAssociatedEventDataViewEntity[] | null;

}

export interface IEventTypeEntity
{
    id?: number;
    name?: string | null;
    displayName?: string | null;
    disabled?: boolean;
    eventFields?: IEventTypeToEventFieldEntity[] | null;
    eventPrimaryKeyFieldId?: number | null;
    eventPrimaryKeyField?: IEventFieldEntity;
    eventTimeFieldId?: number | null;
    eventTimeField?: IEventFieldEntity;

}

export interface IEventTypeToEventFieldEntity
{
    eventTypeId?: number;
    eventType?: IEventTypeEntity;
    eventFieldId?: number;
    eventField?: IEventFieldEntity;
    inputAliases?: string | null;

}

export interface IEventFieldEntity
{
    id?: number;
    name?: string | null;
    isArray?: boolean | null;
    builtInType?: BuiltInType;
    eventTypes?: IEventTypeToEventFieldEntity[] | null;
    validationFunctionParameter?: string | null;
    validationFunctionName?: string | null;

}

export type BuiltInType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19;

export type EventTypePageType = 0 | 1;

export interface IEventTypePageEntityEMServiceRoleIdentity
{
    eventTypePageEntityId?: number;
    eventTypePageEntity?: IEventTypePageEntity;
    identityRoleId?: string | null;
    identityRole?: IEMServiceRoleIdentity;

}

export interface IEMServiceRoleIdentity
{
    id?: string | null;
    name?: string | null;
    normalizedName?: string | null;
    concurrencyStamp?: string | null;
    canLockEvents?: boolean;
    canUnlockEvents?: boolean;
    identityProviderId?: number;
    identityProvider?: IIdentityProvider;
    groupId?: string | null;
    applicationActions?: string | null;
    advancedSecurityEntities?: IAdvancedSecurityEntity[] | null;
    roleUsers?: IEMUserRole[] | null;
    email?: string | null;
    isOwner?: OwnerStateEnum;
    parentId?: string | null;
    parent?: IEMServiceRoleIdentity;
    children?: IEMServiceRoleIdentity[] | null;

}

export interface IIdentityProvider
{
    id?: number;
    name?: string | null;
    securityProviderTypeId?: SecurityProviderEnum;
    clientId?: string | null;
    tenantDomain?: string | null;
    tenantId?: string | null;
    clientSecret?: string | null;
    additionalAudiences?: string | null;
    nameClaimType?: string | null;
    minPasswordLength?: number | null;
    maxPasswordAge?: number | null;
    passwordComplexity?: number | null;
    lastSyncInfo?: string | null;
    lastSyncStatus?: LastSyncStatusEnum;
    lastSync?: string | null;
    isDefault?: boolean;
    users?: IApplicationUser[] | null;
    costCodeAttribute?: string | null;

}

export type SecurityProviderEnum = 0 | 1 | 2;

export type LastSyncStatusEnum = 0 | 1;

export interface IApplicationUser
{
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    userDetails?: string | null;
    userPreferences?: string | null;
    identityProviderId?: number;
    identityProvider?: IIdentityProvider;
    loginIdentityProviderId?: number | null;
    loginIdentityProvider?: IIdentityProvider;
    userLocation?: string | null;
    userType?: UserTypeEnum;
    pin?: string | null;
    departmentsLink?: IDepartments2Users[] | null;
    userRoles?: IEMUserRole[] | null;
    userDetailsAsDictionary?: any | null;
    firstName?: string | null;
    lastName?: string | null;
    givenName?: string | null;
    surname?: string | null;
    displayName?: string | null;
    jobTitle?: string | null;
    businessPhones?: string | null;
    city?: string | null;
    companyName?: string | null;
    country?: string | null;
    department?: string | null;
    employeeId?: string | null;
    mobilePhone?: string | null;
    officeLocation?: string | null;
    preferredName?: string | null;
    state?: string | null;
    streetAddress?: string | null;
    deleted?: DeletedStateEnum;
    deletedAt?: string | null;
    oid?: string | null;
    userStatus?: number;
    openRecords?: string | null;

}

export type UserTypeEnum = 0 | 1;

export interface IDepartments2Users
{
    userId?: string | null;
    user?: IApplicationUser;
    departmentId?: number;
    department?: IDepartment;

}

export interface IDepartment
{
    id?: number;
    name?: string | null;
    parentId?: number | null;
    parent?: IDepartment;
    children?: IDepartment[] | null;
    usersLink?: IDepartments2Users[] | null;

}

export interface IEMUserRole
{
    userId?: string | null;
    roleId?: string | null;
    user?: IApplicationUser;
    role?: IEMServiceRoleIdentity;

}

export type DeletedStateEnum = 0 | 1;

export interface IAdvancedSecurityEntity
{
    id?: number;
    roleId?: string | null;
    role?: IEMServiceRoleIdentity;
    eventTypeId?: number;
    eventType?: IEventTypeEntity;
    nodeIds?: string | null;
    recursiveNodes?: boolean;
    create?: AdvancedSecurityRightsAccessEnum;
    read?: AdvancedSecurityRightsAccessEnum;
    update?: AdvancedSecurityRightsAccessEnum;
    delete?: AdvancedSecurityRightsAccessEnum;
    lock?: AdvancedSecurityRightsAccessEnum;
    unlock?: AdvancedSecurityRightsAccessEnum;
    append?: AdvancedSecurityRightsAccessEnum;
    appendTo?: AdvancedSecurityRightsAccessEnum;
    share?: AdvancedSecurityRightsAccessEnum;
    nodesAsList?: number[] | null;

}

export type AdvancedSecurityRightsAccessEnum = 0 | 1 | 2 | 4;

export type OwnerStateEnum = 0 | 1;

export interface IEventFieldGroupEntity
{
    id?: number;
    name?: string | null;
    infoText?: string | null;
    expression?: string | null;
    collapsed?: boolean;
    order?: number;
    eventFieldsGroupEventFields?: IEventFieldGroupEventField[] | null;

}

export interface IEventFieldGroupEventField
{
    eventFieldGroupEntityId?: number;
    eventFieldGroup?: IEventFieldGroupEntity;
    eventFieldId?: number;
    eventField?: IEventFieldEntity;
    visible?: boolean;
    displayName?: string | null;
    useBtnWidget?: boolean;
    defaultValue?: string | null;
    associatedGroups?: string | null;
    readOnly?: boolean;
    required?: boolean;
    useTextarea?: boolean;
    order?: number;
    value?: string | null;

}

export interface IAssociatedEventDataViewEntity
{
    id?: number;
    label?: string | null;
    urlParams?: string | null;
    eventsDataView?: IEventListViewSettingsEntity;

}

export interface IEventListViewColumnEntity
{
    id?: number;
    order?: number;
    width?: number;
    visible?: boolean;
    wordWrap?: boolean;
    displayName?: string | null;
    columnOrder?: ColumnOrderEnum;
    filter?: string | null;
    eventField?: IEventFieldEntity;

}

export type ColumnOrderEnum = 0 | 1 | 2;

export interface IEventListViewSettingsEntityEventTypePageEntity
{
    eventListViewSettingsEntityId?: number;
    eventListViewSettingsEntity?: IEventListViewSettingsEntity;
    eventTypePageEntityId?: number;
    eventTypePageEntity?: IEventTypePageEntity;

}

export interface IEventListViewSettingsEntityEMServiceRoleIdentity
{
    eventListViewSettingsEntityId?: number;
    eventListViewSettingsEntity?: IEventListViewSettingsEntity;
    identityRoleId?: string | null;
    identityRole?: IEMServiceRoleIdentity;

}

export interface IIdentityProvidePostModel
{
    securityProviderTypeId?: number;
    minPasswordLength?: number | null;
    maxPasswordAge?: number | null;
    passwordComplexity?: number | null;
    clientId?: string | null;
    tenantDomain?: string | null;
    tenantId?: string | null;
    clientSecret?: string | null;
    name?: string | null;
    additionalAudiences?: string | null;
    nameClaimType?: string | null;
    status?: number;
    isDefault?: boolean;

}

export interface IIdentityPutModel
{
    securityProviderTypeId?: number | null;
    clientId?: string | null;
    tenantDomain?: string | null;
    minPasswordLength?: number | null;
    maxPasswordAge?: number | null;
    passwordComplexity?: number | null;
    tenantId?: string | null;
    clientSecret?: string | null;
    name?: string | null;
    additionalAudiences?: string | null;
    nameClaimType?: string | null;
    status?: number | null;
    isDefault?: boolean | null;

}

export interface ILandingTileEntity
{
    id?: number;
    title?: string;
    description?: string | null;
    link?: string | null;
    image?: string | null;
    order?: number;
    disableRemoving?: boolean;
    roles?: ILandingTileEntityIdentityRole[] | null;
    parentId?: number | null;
    parent?: ILandingTileEntity;
    children?: ILandingTileEntity[] | null;

}

export interface ILandingTileEntityIdentityRole
{
    landingTileEntityId?: number;
    landingTileEntity?: ILandingTileEntity;
    identityRoleId?: string | null;
    identityRole?: IEMServiceRoleIdentity;

}

export interface INotificationPostVM
{
    ruleExpression?: string | null;
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    replyTo?: string | null;
    subject?: string | null;
    message?: string | null;
    name?: string | null;
    disabled?: boolean;
    isHTML?: boolean;
    attachmentType?: number;
    officeExportId?: number | null;
    notificationArea?: number;
    shouldSendMail?: boolean;
    shouldSendMobilePush?: boolean;
    mobilePushTo?: string | null;
    shouldSendTwilio?: boolean;
    twilioTo?: string | null;
    mobilePushMessage?: string | null;
    mobilePushTitle?: string | null;
    mobilePushAction?: string | null;
    mobilePushBadge?: string | null;
    twilioMessage?: string | null;
    mobilePushActionUri?: string | null;
    eventTypeName?: string | null;

}

export interface INotificationUpdateVM
{
    ruleExpression?: string | null;
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    replyTo?: string | null;
    subject?: string | null;
    message?: string | null;
    name?: string | null;
    disabled?: boolean | null;
    isHTML?: boolean | null;
    attachmentType?: number | null;
    officeExportId?: number | null;
    notificationArea?: number | null;
    shouldSendMail?: boolean | null;
    shouldSendMobilePush?: boolean | null;
    mobilePushTo?: string | null;
    shouldSendTwilio?: boolean | null;
    twilioTo?: string | null;
    mobilePushMessage?: string | null;
    mobilePushTitle?: string | null;
    mobilePushAction?: string | null;
    mobilePushBadge?: string | null;
    twilioMessage?: string | null;
    mobilePushActionUri?: string | null;
    concurrencyTimestamp?: string | null;
    eventTypeName?: string | null;

}

export interface ISecurityModelUpdateModel
{
    id?: number;
    eventTypeId?: number;
    nodeIds?: string | null;
    recursiveNodes?: boolean;
    create?: number;
    read?: number;
    update?: number;
    delete?: number;
    lock?: number;
    unlock?: number;
    append?: number;
    appendTo?: number;
    share?: number;

}

export interface IRolesPostModel
{
    name?: string | null;
    groupId?: string | null;
    applicationActions?: string | null;
    identityProviderId?: number | null;
    isOwner?: number;
    email?: string | null;

}

export interface IRolesPutModel
{
    name?: string | null;
    groupId?: string | null;
    applicationActions?: string | null;
    concurrencyStamp?: string | null;
    identityProviderId?: number | null;
    isOwner?: number;
    email?: string | null;

}

export interface IPostSpace
{
    spaceId?: string | null;
    name?: string | null;
    code?: string | null;
    spaceType?: SpaceType;
    type?: Type;
    personCapacity?: number;
    grossArea?: number;
    isSearchable?: number;
    isEnabled?: number;
    isPartOf?: number | null;
    ownedBy?: string | null;
    operatedBy?: string | null;
    mapUri?: string | null;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    longitude?: string | null;
    latitude?: string | null;
    parameter?: any | null;

}

export type SpaceType = 0 | 1 | 3 | 4 | 5 | 6 | 7 | 8;

export type Type = 0 | 1 | 2 | 4 | 5 | 6 | 7 | 8 | 9;

export interface IUpdateSpace
{
    concurrencyStamp?: string | null;
    name?: string | null;
    code?: string | null;
    spaceType?: SpaceType;
    type?: Type;
    personCapacity?: number | null;
    grossArea?: number | null;
    isSearchable?: number | null;
    isEnabled?: number | null;
    isPartOf?: number | null;
    ownedBy?: string | null;
    operatedBy?: string | null;
    mapUri?: string | null;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    longitude?: string | null;
    latitude?: string | null;
    parameter?: any | null;

}

export interface IPostUserAddRoleModel
{
    userId?: string | null;
    roleId?: string | null;

}

export interface IUserPostModel
{
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    email?: string | null;
    password?: string | null;
    phoneNumber?: string | null;
    identityProviderId?: number;
    userPreferences?: string | null;
    userLocation?: string | null;
    passwordHash?: string | null;
    userType?: number;

}

export interface IUpdateUserModel
{
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    userPreferences?: string | null;
    userLocation?: string | null;
    concurrencyStamp?: string | null;
    identityProviderId?: number | null;

}
